import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LogIn, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem('mbe_admin_token');
    if (t) nav('/admin/dashboard');
  }, [nav]);

  async function submit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('mbe_admin_token', r.data.access_token);
      localStorage.setItem('mbe_admin_user', r.data.username);
      nav('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
      <div className="relative w-full max-w-md card-dark p-8">
        <div className="font-display text-white text-2xl md:text-3xl mb-1">MBE Admin</div>
        <p className="text-[#f2f2f2] text-sm mb-6">Sign in to manage country links and view analytics.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[#f2f2f2] text-[12px] uppercase tracking-wider">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 w-full bg-white/[0.04] border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm outline-none focus:border-orange-400/70"
              required
            />
          </div>
          <div>
            <label className="text-[#f2f2f2] text-[12px] uppercase tracking-wider">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full bg-white/[0.04] border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm outline-none focus:border-orange-400/70"
              required
            />
          </div>

          {error && <div className="text-red-300 text-sm">{error}</div>}

          <button
            type="submit"
            disabled={loading}
            className="btn-orange w-full inline-flex items-center justify-center gap-2 px-4 py-3 text-[14px]"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
            Sign In
          </button>
        </form>

        <div className="mt-6 text-[11px] text-[#f2f2f2] leading-relaxed">
          Default credentials on first launch:<br/>
          username: <span className="text-white">admin</span> &middot; password: <span className="text-white">mbe@2025</span>
        </div>
      </div>
    </div>
  );
}
